import { Component, inject, OnInit, signal } from '@angular/core';
import { CertPolicies } from 'src/auth/cert-policies';
import { AuthService } from 'src/auth/services/auth.service';
import { LeaCodeService } from 'src/auth/services/lea-code.service';
import { LeaProfessionalDevelopmentClient } from 'src/shared/services/api.service';
import { FeatureManagementService } from 'src/shared/services/feature-management.service';

@Component({
  selector: 'cert-lea2-nav-menu',
  templateUrl: './lea2-nav-menu.component.html',
  styles: `
    .nav-described .dropdown-menu {
      min-width: 19rem;
      padding: 0.5rem 0;
    }

    .nav-described .dropdown-item {
      font-size: 1.05rem;
      padding: 0.6rem 1.25rem;
    }

    .nav-described .dropdown-item small {
      font-size: 0.78rem;
      margin-top: 0.15rem;
    }

    .nav-described .dropdown-header {
      font-size: 0.7rem;
      font-weight: 600;
      letter-spacing: 0.06em;
      padding: 0.5rem 1.25rem 0.25rem;
    }

    .nav-described .dropdown-divider {
      margin: 0.5rem 0;
    }
  `,
  standalone: false,
})
export class Lea2NavMenuComponent implements OnInit {
  private readonly featureManager = inject(FeatureManagementService);
  private readonly authService = inject(AuthService);
  private readonly professionalDevelopmentClient = inject(LeaProfessionalDevelopmentClient);
  private readonly leaCodeService = inject(LeaCodeService);

  complexProfessionalDevelopmentEnabled = signal(false);
  workforceManagementEnabled$ = this.featureManager.isFeatureEnabled('lea2WorkforceManagement');
  legacyLea2WorkforceEnabled$ = this.featureManager.isFeatureEnabled('legacyLea2Workforce');
  vouchersEnabled$ = this.featureManager.isFeatureEnabled('vouchers');

  pendingPDRequestsCount = signal(0);
  selectedLeaCodeId: number | null = null;

  canManageLeaUploads: boolean = this.authService.hasPolicy(CertPolicies.CanManageLeaUploads);
  canManageLeaStaffRoster: boolean = this.authService.hasPolicy(CertPolicies.CanManageLeaStaffRoster);
  canVerifyProfessionalDevelopment: boolean = this.authService.hasPolicy(CertPolicies.CanVerifyProfessionalDevelopment);

  ngOnInit() {
    this.leaCodeService.getCurrentLeaCodeId().subscribe({
      next: (leaCodeId) => {
        this.selectedLeaCodeId = leaCodeId;
        if (this.complexProfessionalDevelopmentEnabled()) {
          this.getPendingPDRequestsCount();
        }
      },
    });

    this.featureManager.isFeatureEnabled('complexProfessionalDevelopment').subscribe((enabled) => {
      this.complexProfessionalDevelopmentEnabled.set(enabled);
      if (enabled && this.selectedLeaCodeId !== null) {
        this.getPendingPDRequestsCount();
      }
    });
  }

  getPendingPDRequestsCount() {
    if (this.selectedLeaCodeId !== null && this.canVerifyProfessionalDevelopment) {
      this.professionalDevelopmentClient
        .getTotalCountOfPendingProfessionalDevelopmentRequests(this.selectedLeaCodeId)
        .subscribe((count) => {
          this.pendingPDRequestsCount.set(count);
        });
    }
  }
}
